import { app } from '../../core/App';
import { Sounds } from '../../sounds';
import { DriverProfile, Vehicle, VehicleDetails, VehicleHandling } from './Vehicle';
import { EquipmentType, EquipmentTypeValues } from './VehicleEquipment';
import { VehicleEquipmentCapture } from './VehicleEquipmentCapture';
import { VehicleCaptureMagCable } from './equipment-capture/VehicleCaptureMagCable';
import { VehicleCaptureCrane } from './equipment-capture/VehicleCaptureCrane';
import { VehicleManager } from './VehicleManager';
import { RoadDetails } from '../level/themes/theme';
import { VehicleCaptureGrapple } from './equipment-capture/VehicleCaptureGrapple';
import { VehicleCaptureLaser } from './equipment-capture/VehicleCaptureLaser';
import { VehicleCaptureNetSteel } from './equipment-capture/VehicleCaptureNetSteel';

export class VehicleHero extends Vehicle {
  protected weapon: VehicleEquipmentCapture | undefined;
  // protected isHit: boolean = false;

  constructor(
    scene: Phaser.Scene,
    vehicleManager: VehicleManager,
    driverProfile: DriverProfile,
    vehicleHandling: VehicleHandling,
    roadDetails: RoadDetails,
    vehicleDetails: VehicleDetails
  ) {
    super(scene, vehicleManager, driverProfile, vehicleHandling, roadDetails, vehicleDetails);
    this.setupEquipment(this.driverProfile.equipment);
  }

  get Weapon(): VehicleEquipmentCapture | undefined {
    return this.weapon;
  }

  // public onHitBackStart() {
  //   this.isHit = true;
  // }

  // public onHitBackEnd() {
  //   this.isHit = false;
  // }

  public cheer() {
    app.audioHandler.playSound(this.scene, this.sounds.cheer, Sounds.Channel.SFX, { volume: 1.0 });
  }

  public captureFire() {
    this.weapon?.triggerCaptureFire();
  }

  protected setupEquipment(equipment: EquipmentTypeValues[]) {
    for (const equipmentType of equipment) {
      switch (equipmentType) {
        case EquipmentType.MagCable:
          let magCable = new VehicleCaptureMagCable(this.scene, this);
          this.weapon = magCable;
          this.equipment.push(magCable);
          break;
        case EquipmentType.Grapple:
          let grapple = new VehicleCaptureGrapple(this.scene, this);
          this.weapon = grapple;
          this.equipment.push(grapple);
          break;
        case EquipmentType.Laser:
          let laser = new VehicleCaptureLaser(this.scene, this);
          this.weapon = laser;
          this.equipment.push(laser);
          break;
        case EquipmentType.NetSteel:
          let netSteel = new VehicleCaptureNetSteel(this.scene, this);
          this.weapon = netSteel;
          this.equipment.push(netSteel);
          break;
        case EquipmentType.Crane:
          let crane = new VehicleCaptureCrane(this.scene, this);
          this.weapon = crane;
          this.equipment.push(crane);
        default:
          break;
      }
    }
  }
}
